// A coach who opened the account with a text code has proven the mobile,
// not the email their coach record is keyed by. Until Continue with Google
// or a reset link confirms that email, the server refuses to verify them or
// give them a team code, a team or a league-admin grant (409
// email_unproven, for any account the Manage teams dialog opens), so the
// admin tools flag them and hold those actions.
export const coachEmailUnproven = (row) => !!row?.emailUnproven && (row?.permissions || []).includes('IS_COACH');

export const EMAIL_UNPROVEN_LABEL = 'Email not confirmed (signed up by text)';
export const EMAIL_UNPROVEN_HINT = 'They confirm it with Continue with Google or Forgot password before they can be verified.';

// The server's own words for a refused admin change: its `message`, else
// its `error`, else `fallback`.
export const refusalMessage = (err, fallback) => err?.response?.data?.message || err?.response?.data?.error || fallback;
